import React from 'react'
import RadioButton from '../RadioButton'
import './RadioOption.scss'

const RadioOption = ({ label, isChecked, onClick }) => {

  return (
    <div className='radiooption-container'>
      <RadioButton
        checked={isChecked}
        handleChange={onClick}
      />
      <p>{label}</p>
    </div>
  )

}

export default RadioOption
